import {Component, OnInit, ViewChild} from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {FlowComponent} from './flow/flow.component';
import {Toast} from '../../shared/toast/toast';

@Component({
   selector: 'app-view-flow',
   templateUrl: './view-flow.component.html',
   styleUrls: ['./view-flow.component.css']
})
export class ViewFlowComponent implements OnInit {

   id: number;
   taskStatus: string;
   @ViewChild(FlowComponent, { static: true }) flow: FlowComponent;

   constructor(private dialog: MatDialog, private toast: Toast, protected service: IdexService) {
   }

   ngOnInit() {
      this.flow.isTask = true;
      this.flow.taskStatus = this.taskStatus;
      this.flow.getFlowList(this.id);
   }


}
